import { combineReducers } from "redux";
import user from "./user";
import driver from "./driver";
import translation from "./translation";
import gameplay from "./gameplay";
import fixture from "./fixture";
import constraints from "./constraints";
import country from "./country";
import circuit from "./circuit";
import league from "./league";
import leaderboard from "./leaderboard";
import statistics from "./statistics";
import mixapi from "./mixapi";
import footerPartners from "./footerPartners";
import geolocationV2 from "./geolocationV2";
import ageGateConfig from "./ageGateConfig";
import menu from "./menu";
import eos from "./eos";
import webconfig from "./webconfig";
import homepage from "./homepage";
import seasonPerformance from "./seasonPerformance";
import completeYourProfile from "./complete-your-profile";
import cloudinary from "./cloudinary";
import commonConfig from "./commonConfig";
import fixtureCircuitConfig from "./fixtureCircuitConfig";
import masterConfig from "./masterConfig";
import masterManifest from "./masterManifest";
import sponsors from "./sponsors";

export default combineReducers({
  user,
  driver,
  translation,
  gameplay,
  fixture,
  constraints,
  country,
  circuit,
  league,
  leaderboard,
  statistics,
  mixapi,
  footerPartners,
  geolocationV2,
  ageGateConfig,
  menu,
  eos,
  webconfig,
  homepage,
  seasonPerformance,
  completeYourProfile,
  cloudinary,
  commonConfig,
  fixtureCircuitConfig,
  masterConfig,
  masterManifest,
  sponsors,
});
